import React from 'react'

export default function IconParagraph({
    children,
}) {

    return (
        <div className='flex items-center'>
            <div className='flex items-center justify-center bg-light rounded-xl w-12 h-12'>
            </div>

            <div className='pl-4'>
                {children}
            </div>
        </div>
    )
}
